import type { KyInstance } from 'ky'
import ApiAuth from './auth'
import ApiBraintree from './braintree'
import ApiCheckout from './checkout'
import ApiCustomers from './customers'
import ApiCountries from './countries'
import ApiUsers from './users'
import ApiPartners from './partners'
import ApiSubscriptions from './subscriptions'
import ApiUrlPrefix from './url-prefix'
import ApiPrices from './prices'
import ApiVat from './vat'
import ApiVersion from './version'
import ApiInvoices from './invoices'
import ApiCreditNotes from './credit-notes'
import ApiAdmin from './admin'
import ApiAdminUsers from './admin-users'
import ApiVouchers from './vouchers'
import ApiEvents from './events'
import ApiFeatureFlags from './feature-flags'
import ApiSearch from './search'
import ApiMonitoring from './monitoring'
import ApiNotificationBanner from './notification-banner'
import ApiActivityLogs from './activity-logs'
import ApiEmailLogs from './email-logs'

export interface Api extends KyInstance {
  auth: ApiAuth
  braintree: ApiBraintree
  checkout: ApiCheckout
  customers: ApiCustomers
  countries: ApiCountries
  users: ApiUsers
  partners: ApiPartners
  subscriptions: ApiSubscriptions
  urlPrefix: ApiUrlPrefix
  prices: ApiPrices
  vat: ApiVat
  version: ApiVersion
  invoices: ApiInvoices
  creditNotes: ApiCreditNotes
  admin: ApiAdmin
  adminUsers: ApiAdminUsers
  vouchers: ApiVouchers
  events: ApiEvents
  featureFlags: ApiFeatureFlags
  search: ApiSearch
  monitoring: ApiMonitoring
  notificationBanner: ApiNotificationBanner
  activityLogs: ApiActivityLogs
  emailLogs: ApiEmailLogs
}

export class ApiKy {
  ky: KyInstance
  url: string

  constructor(api: KyInstance, url: string) {
    this.ky = api
    this.url = url
  }
}
